import Ember from 'ember-js';
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

// Uncomment the following line to import an animation from Ember.
import fadeMotionEntrance from '../ember-animations/fade-motion';
import fadeEntrance from '../ember-animations/fade';
import fadeLetters from '../ember-animations/fade-letters';
import fadeWords from '../ember-animations/fade-words';
import roll from '../ember-animations/roll';
import slideWords from '../ember-animations/slide-words';

// Initialize Ember.
window.ember = new Ember();
window.gsap = gsap;

gsap.registerPlugin(ScrollTrigger);

// Register Ember animation types.
window.ember.registerAnimations('entrance', [
    fadeMotionEntrance,
    fadeEntrance,
    fadeLetters,
    fadeWords,
    roll,
    slideWords,
]);

// Set Ember animation defaults.
window.ember.setDefaults({
    /**
     * The delay in milliseconds between each element being animated.
     */
    delayBetween: 200,

    /**
     * The offset in pixels from the bottom of the viewport before an element is animated.
     */
    rootMargin: '0px 0px -100px 0px',

    /**
     * Use the following to set the default animation categories.
     * These are useful for determining which animations to use for different element types.
     *
     * Using the default animation for a given category is as simple as appending the category
     * to the "ember-entrance" class on the element, e.g. "ember-entrance--alt".
     *
     * By default, all elements will use the "primary" animation, even if no category is specified.
     * E.g. if the element has the "ember-entrance" class, it will use the "primary" animation.
     */
    defaultAnimations: {
        // Do not remove the primary category, as it is used as a fallback.
        primary: 'fade-motion',
        static: 'fade',
        letters: 'fade-letters',
        words: 'fade-words',
        roll: 'roll',
        slideWords: 'slide-words',
    },

    /**
     * Animation options are applied based on priority. The list below shows the order
     * in which options are applied, with the highest priority at the top.
     *
     * If an option is found in one of the following places, it will be used and the search will stop.
     *
     * 1. Animation options provided in the element (HTML attributes following the pattern: [data-entrance-anim-{option}]).
     * 2. Global defaults for this animation (see perAnimationOptions).
     * 3. Animation defaults (see defaultOptions in each animation declaration).
     * 4. Global defaults for all animations (see animationOptions).
     */

    /**
     * The following options are used as a last resort if no other options are provided.
     *
     * This is also a good place to set options that all animations should use, ensuring
     * consistency across the site.
     *
     * All options you can set here can also be set per animation (see perAnimationOptions).
     */
    animationOptions: {
        /**
         * The duration in seconds for all animations.
         */
        duration: 0.3,

        /**
         * The offset in pixels to start a motion animation from.
         *
         * For example, the "fade-motion" animation will start from 50px below the bottom of the viewport.
         * If you change the animation direction to "right", the animation will start from 50px to the left of the viewport.
         */
        offset: 50,

        /**
         * The easing function to use for all animations.
         *
         * Possible values can be found here: https://gsap.com/docs/v3/Eases
         */
        easing: 'power2.out',
    },

    /**
     * The following options are applied per animation.
     *
     * This is a good place to set options that all animations of a given type should use,
     * ensuring consistency across the site.
     */
    perAnimationOptions: {
        entrance: {
            'fade': {
                duration: 0.5,
            },
            'fade-motion': {
                duration: 0.6,
            },
        },
    },
});

// Initialize Ember when the DOM is ready.
window.addEventListener('DOMContentLoaded', () => ember.init());